import React, { useState } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css"; // Use Material UI styling
import commonStyles from "../../../styles/common.module.css";

interface Props {
  onClick: () => void;
}

const PhoneNumber = ({ onClick }: Props) => {
  const [phone, setPhone] = useState("");
  const [error, setError] = useState(false);

  const handleChange = (value: string) => {
    sessionStorage.setItem("phoneNumber", value );
    const phoneNumber = value.replace(/\D/g, "").slice(1, 11);
    setPhone(phoneNumber);
  
    if(phoneNumber.length != 10){
      setError(true)
    }
    else{
      setError(false)
    }
  };

  return (
    <div className={commonStyles.phoneNumberContainer}>
      <div>
        <h1 className={commonStyles.header}>Phone Number</h1>
        <span className={commonStyles.description}>
          Enter your registered phone number
        </span>
      </div>

      <div className={commonStyles.phoneInputWrapper}>
        <PhoneInput
          country={"ca"}
          onlyCountries={["us", "ca"]} 
          value={`+1${phone}`}
          onChange={handleChange}
          inputProps={{
            required: true,
            autoFocus: true,
          }}
          isValid={(value) => value.replace(/\D/g, "").length === 10}
          containerClass={commonStyles.phoneInputContainer }
          inputClass={`${commonStyles.phoneInput} ${error ? commonStyles.inputError : commonStyles.noInputError}`}
          buttonClass={commonStyles.phoneDropdown}
        />
           {error && <span className={commonStyles.errorText}>Enter a valid 10-digit phone number</span>}
      </div>

   

      <button
        onClick={() => {
          if (!error) onClick();
        }}
        className={`${phone.length !== 10 ? commonStyles.button_primary_disabled : commonStyles.button_primary}`}
        disabled={phone.length !== 10}
      >
        Continue
      </button>
    </div>
  );
};

export default PhoneNumber;
